import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from '../ui/card';

const StatCard = ({ 
  title, 
  value, 
  icon: Icon, 
  color = 'red',
  trend,
  trendValue,
  onClick 
}) => {
  const colors = {
    red: 'bg-red-500/20 text-red-400',
    orange: 'bg-orange-500/20 text-orange-400',
    blue: 'bg-blue-500/20 text-blue-400',
    green: 'bg-green-500/20 text-green-400',
    purple: 'bg-purple-500/20 text-purple-400',
    zinc: 'bg-zinc-500/20 text-zinc-400',
  };

  const colorClass = colors[color] || colors.red;

  return (
    <motion.div
      whileHover={{ scale: onClick ? 1.02 : 1 }}
      whileTap={{ scale: onClick ? 0.98 : 1 }}
    >
      <Card 
        className={`bg-zinc-900 border-zinc-800 ${onClick ? 'cursor-pointer hover:border-zinc-700 transition-colors' : ''}`}
        onClick={onClick}
      >
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-zinc-500 uppercase tracking-wider">{title}</p>
              <p className="text-2xl font-bold text-white mt-1">{value}</p>
              {trend && (
                <p className={`text-xs mt-1 ${trend === 'up' ? 'text-green-400' : trend === 'down' ? 'text-red-400' : 'text-zinc-500'}`}>
                  {trend === 'up' ? '↑' : trend === 'down' ? '↓' : '→'} {trendValue}
                </p>
              )}
            </div>
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${colorClass}`}>
              <Icon className="w-5 h-5" />
            </div>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default StatCard;
